<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">

        <NotificationsDropdown/>

        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>

        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item>

        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" />
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://coreui.io">CoreUI</a>
        <span class="ml-1">&copy; 2018 creativeLabs.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import {
  Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader,
  SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb
} from '@coreui/vue';
import { mapGetters } from 'vuex';
import nav from '../_nav';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import NotificationsDropdown from '@/views/public/Notifications/NotificationsDropdown';

export default {
  name: 'DefaultContainer',
  beforeMount() {
    if (!this.token) {
      this.$router.push({ name: 'Login' });
    }
  },
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    NotificationsDropdown
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('Auth', [
      'token', 'user', 'abilities'
    ]),
    nav() {
      const availableItems = [];
      const allItems = JSON.parse(JSON.stringify(nav.items));
      for (const item of allItems) {
        if (item.children) {
          const childs = item.children.filter((child) => this.hasAccess(child.permissions));
          if (childs.length) {
            item.children = childs;
            item.children.map((element) => {
              element.name = this.$t(element.name, 'global');
              return element;
            });
            availableItems.push(item);
          }
        } else if (this.hasAccess(item.permissions)) {
          item.name = this.$t(item.name, 'global');
          availableItems.push(item);
        }
      }
      return JSON.parse(JSON.stringify(availableItems));
    },
    name() {
      return this.$route.name;
    },
    list() {
      const list = this.$route.matched.filter((route) => route.name || route.meta.label);
      list.map((route) => {
        if (route.meta.label) {
          route.meta.label = this.$t(route.meta.label, 'global');
        }
        return route;
      });
      return list;
    }
  },
  methods: {
    hasAccess(requiredPermissions) {
      if (requiredPermissions) {
        const [subject, actions] = requiredPermissions[0].split('.');
        return this.$ability.can(actions, subject);
      }
      return true;
    }
  },
};
</script>
